import { memo } from 'react';
import styles from './Loader.module.scss';

const Loader = () => {
    return <div className={styles.holder} style={{ backgroundImage: 'url(/images/icon-loader.svg)' }}></div>;
};

export default memo(Loader);
